import { MagnifyingGlass } from '@phosphor-icons/react/dist/ssr'
import {
  Button,
  DatePicker,
  Form,
  Popover,
  type TimeRangePickerProps,
} from 'antd'
import dayjs from 'dayjs'
import { useState } from 'react'

import { useUpdateURLSearchParams } from '@/hooks/useQuery'
import useSearchParams from '@/hooks/useSearchParams'
import FormAntd from '@/ui/form/antd/FormAntd'

export const CustomPeriod = () => {
  const [isOpen, setIsOpen] = useState(false)
  const searchParams = useSearchParams()
  const updateParams = useUpdateURLSearchParams()

  const startDate = searchParams.get('start_date')
  const endDate = searchParams.get('end_date')

  const initialValues =
    startDate && endDate
      ? {
          start_date: [dayjs(startDate), dayjs(endDate)],
        }
      : undefined

  const disabledDate = (current: dayjs.Dayjs) => {
    return current && current > dayjs().endOf('day')
  }
  const rangePresets: TimeRangePickerProps['presets'] = [
    { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: 'Last 14 Days', value: [dayjs().add(-14, 'd'), dayjs()] },
    { label: 'Last 30 Days', value: [dayjs().add(-30, 'd'), dayjs()] },
    { label: 'Last 90 Days', value: [dayjs().add(-90, 'd'), dayjs()] },
  ]

  const onFinish = (values: { start_date: [dayjs.Dayjs, dayjs.Dayjs] }) => {
    const [startDate, endDate] = values.start_date
    updateParams(
      ['start_date', startDate.format('YYYY-MM-DD')],
      ['end_date', endDate.format('YYYY-MM-DD')]
    )
    setIsOpen(false)
  }

  return (
    <Popover
      content={
        <FormAntd.Root
          className="flex flex-row items-end gap-3"
          initialValues={initialValues}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item className="!mb-0" label="Choose Date" name="start_date">
            <DatePicker.RangePicker
              disabledDate={disabledDate}
              format="MM/DD/YYYY"
              presets={rangePresets}
              type="mask"
            />
          </Form.Item>
          <Button
            className="flex h-9 items-center gap-2 !px-2 !py-0"
            htmlType="submit"
            type="primary"
          >
            <MagnifyingGlass className="text-xl" weight="bold" />
          </Button>
        </FormAntd.Root>
      }
      onOpenChange={setIsOpen}
      open={isOpen}
      placement="bottom"
      trigger="click"
    >
      Custom
    </Popover>
  )
}
